export const initialValues = {
  homepage: {
    // ga_document_host: "",
    // initial_location: "",
    // appeal_id: "",
    // appeal_name: "",
    // ga_client_id: "",
    // ga_tracking_id: "",
    // gtm_container_id: "",
    // session_id: "",
    payment_type: "Single",
    payment_method: "",
    amount: 0,
    optins_email: false,
    optins_post: false,
    optins_phone: false,
    optins_giftaid: false,
    salutation: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    membership_number: "",
    organisation: "",
    // address_search: "",
    address_1: "",
    address_2: "",
    address_3: "",
    town_city: "",
    county_state: "",
    postcode: "",
    country: "GB",
    message_to_charity: "",
    manually_transferred_to_crm: false
  },
  payment_regular: {
    bank_account_account_name: "",
    bank_account_account_number: "",
    bank_account_sort_code: "",
    bank_account_number_redacted: ""
  }
}

export default initialValues